<template>
	<v-card 
		class="text-center mx-auto"
		max-width="600"
		width="100%"
		flat
	>
		<v-card-item>
			<v-card-title :class="titleClass">
				{{ title }}
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				{{ subtitle }}
			</v-card-subtitle>
		</v-card-item>

		<v-card-text>
			{{ text }}
		</v-card-text>
		<v-card-text class="text-left mx-auto">
			<!-- <v-list lines="two" >
				<v-list-item v-for="(item, index) in value" :key="index"
					:subtitle="item.subtitle"
					:title="item.title"
				>
					<template v-slot:prepend>
						<v-icon :color="item.color" size="x-large">{{ item.icon }}</v-icon>
					</template>

					<template v-slot:append>
						<v-btn
							
							icon="mdi-dots-vertical"
							variant="text"
						></v-btn>
					</template>
				</v-list-item>
			</v-list> -->

			<v-card v-for="(item, index) in value" :key="index"
				class="mx-auto my-1 text-subtitle-2"
				:subtitle="item.subtitle"
				:title="item.title"

				:href="item.href"
				rel="noopener"
				target="_blank"
			>
				<template v-slot:prepend>
					<v-icon size="x-large" :color="item.color" :icon="item.icon"></v-icon>
				</template>
				<template v-slot:append>
					<v-icon color="success" icon="mdi-dots-vertical"></v-icon>
				</template>
				<!-- <v-card-title>{{ item.title }}</v-card-title>
				<v-card-subtitle>{{ item.subtitle }}</v-card-subtitle> -->
			</v-card>
			<!-- 
			:subtitle="item.subtitle"
				:title="item.title"
				append-icon="mdi-dots-vertical"
				:prepend-icon="item.icon"
				href="https://github.com/vuetifyjs/vuetify/"
				max-width="344" 
				rel="noopener"
				target="_blank"
			-->
		</v-card-text>
	</v-card>
</template>

<script>
import mixin from './mixin/main'

export default {
	mixins: [mixin],

	props: {
		modelValue:			{ type: Array, default: () => [] },
	},
}
</script>
